module.exports = __webpack_public_path__ + "img/curetions_door.0a596ef0.png";